import artifact from '$houdini/artifacts/DeleteItinerariesFavorite'
import { MutationStore } from '../runtime/stores/mutation'

export class DeleteItinerariesFavoriteStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
